// The signed-in person's report page setup (lib/pdfPageSetup.js): their own
// Margins / Table size, else the firm default from `firmSettings`.  Re-reads
// when they change it here (PDF_PAGE_SETUP_EVENT) or in another window (the
// storage event), so every open report follows one choice.
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useAuth } from '../context/AuthContext'
import {
  PDF_PAGE_SETUP_EVENT, pdfPageSetupKeyFor, resolvePdfPageSetup, savePersonalPdfPageSetup,
} from '../lib/pdfPageSetup'

export default function usePdfPageSetup (firmSettings) {
  const { user } = useAuth() || {}
  const uid = user && user.id !== undefined && user.id !== null ? String(user.id) : null
  const [version, setVersion] = useState(0)

  useEffect(() => {
    const bump = () => setVersion(v => v + 1)
    // key null: a bulk clear ("Reset UI preferences", lib/uiPrefs.js).
    const onStorage = (e) => { if (e.key === null || (uid && e.key === pdfPageSetupKeyFor(uid))) bump() }
    window.addEventListener(PDF_PAGE_SETUP_EVENT, bump)
    window.addEventListener('storage', onStorage)
    return () => {
      window.removeEventListener(PDF_PAGE_SETUP_EVENT, bump)
      window.removeEventListener('storage', onStorage)
    }
  }, [uid])

  const marginsDefault = firmSettings && firmSettings.report_page_margins
  const sizeDefault = firmSettings && firmSettings.report_table_size
  const setup = useMemo(
    () => resolvePdfPageSetup({ firmSettings: { report_page_margins: marginsDefault, report_table_size: sizeDefault }, userId: uid }),
    [marginsDefault, sizeDefault, uid, version], // eslint-disable-line react-hooks/exhaustive-deps
  )
  const setMargins = useCallback((margins) => { savePersonalPdfPageSetup(uid, { margins }) }, [uid])
  const setTableSize = useCallback((tableSize) => { savePersonalPdfPageSetup(uid, { tableSize }) }, [uid])
  return { setup, setMargins, setTableSize }
}
